export function filterNulls<T>(items: Array<any>): Array<T> {
  return items?.filter(Boolean);
}
